import { t } from "i18next";
// import ChevronRight from "../../Icons/CheronRight";

const BannerModel = ({ currency = {}, onReserve }) => {
  return (
    <div className=" bg-white text-sm py-3 md:text-base  text-black px-5 shadow-xl">
      <div className="flex items-center justify-center ">
        <div className=" font-semibold text-xl md:text-2xl inline-flex space-x-2">
          <span>&nbsp;</span>
        </div>
      </div>
    </div>
  );
};

export default BannerModel;
